enum CaState {
    OVERDUE = "VENCIDO",
    VALID = "VÁLIDO"
}

export default CaState